import { BehaviorSubject, Subscription } from "rxjs";
import { User } from "..";
import { City } from "../city/city.model";
import { Venue } from "../venue/venue.model";
import { AuthType } from "../models";

export class UserFilterService {
  public filtered$: BehaviorSubject<User[]> = new BehaviorSubject<User[]>([]);
  public users: User[];
  public filtered: User[] = [];
  public subscription: Subscription;
  public currentCity: City = null;
  public currentVenue: Venue = null;
  public showLineLeap: boolean = true;
  public showVenue: boolean = true;
  public searchText: string = "";
  itemsPerPage: number[] = [10, 20, 50];
  showing: number = 10;
  firstIndex: number = 0;
  lastIndex: number = 0 + this.showing;
  constructor() {
    this.subscribe();
  }

  reset() {
    this.currentCity = null;
    this.currentVenue = null;
    this.searchText = "";
    this.showLineLeap = true;
    this.showVenue = true;
    this.firstIndex = 0;
    this.lastIndex = this.showing;
  }

  next(users: User[]) {
    this.filtered$.next(users);
  }

  unsubscribe() {
    if (this.subscription != null) this.subscription.unsubscribe();
  }

  subscribe() {
    this.subscription = this.filtered$.subscribe(async users => {
      this.users = users;
      if (this.filtered == null || this.filtered.length == 0)
        this.filtered = users;
      this.filter();
    });
  }

  search(text: string) {
    this.searchText = text;
    this.filter();
  }

  filter() {
    this.filtered = this.users.filter(user => this.shouldFilter(user));
  }

  shouldFilter(user: User) {
    var isAdmin: boolean = user.admin.type == AuthType.LineLeapAdmin;
    var isNullVenue: boolean = this.currentVenue == null;
    var isNullCity: boolean = this.currentCity == null;

    var isAuthorizedVenue =
      !isNullVenue &&
      user.admin.venues != null &&
      user.admin.venues.includes(this.currentVenue.path);

    var isAuthorizedCity =
      isNullCity ||
      (user.admin.cities != null &&
        user.admin.cities.includes(this.currentCity.reference.path));

    var isAuthorized = isAuthorizedCity || isAuthorizedVenue;

    var searchFlag: boolean =
      this.searchText == "" ||
      user.name.toLowerCase().includes(this.searchText.toLowerCase()) ||
      user.email.toLowerCase().includes(this.searchText.toLowerCase());
    var showVenueFlag: boolean =
      this.showVenue &&
      [AuthType.VenueAdmin, AuthType.VenueRead].includes(user.admin.type);
    var showLineLeapFlag: boolean =
      this.showLineLeap &&
      [AuthType.LineLeapAdmin, AuthType.LineLeapRead].includes(user.admin.type);

    return (
      (isAuthorized || isAdmin) &&
      searchFlag &&
      (showVenueFlag || showLineLeapFlag)
    );
  }

  setItemsPerPage(item: number) {
    this.showing = item;
    this.firstIndex = 0;
    this.lastIndex = item;
  }

  show(i: number) {
    return i >= this.firstIndex && i < this.lastIndex;
  }

  increment() {
    if (this.lastIndex <= this.filtered.length) {
      this.firstIndex += this.showing;
      this.lastIndex += this.showing;
    }
  }
  decrement() {
    if (this.firstIndex - this.showing >= 0) {
      this.firstIndex -= this.showing;
      this.lastIndex -= this.showing;
    }
  }
}
